import { useEffect, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import type { CreateAutoCreditProps } from '../../../types/form-types';

type TAddProductsLoanPeriodOptions = {
  value: string;
  label: string;
};

export const addProductsLoanPeriodOptions: TAddProductsLoanPeriodOptions[] = [
  {
    value: '12',
    label: '12 мес.'
  },
  {
    value: '24',
    label: '24 мес.'
  },
  {
    value: '36',
    label: '36 мес.'
  },
  {
    value: '48',
    label: '48 мес.'
  },
  {
    value: '60',
    label: '60 мес.'
  },
  {
    value: '72',
    label: '72 мес.'
  },
  {
    value: '84',
    label: '84 мес.'
  }
];

interface IProps {
  handleChangeAddProductLoanPeriod: (data: {
    value: string;
    id: string;
  }) => void;
}

const useEurasProducts = ({ handleChangeAddProductLoanPeriod }: IProps) => {
  const { control } = useFormContext<CreateAutoCreditProps>();
  const [stockBonds, additionalProducts] = useWatch({
    control,
    name: ['stockBounds', 'additionalProducts']
  });

  const [periodOptions, setPeriodOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [period, setPeriod] = useState<number>();

  useEffect(() => {
    const selectedPeriod = stockBonds.find(
      (promo) => promo.name.includes('Евразийский') && promo.checked
    );
    if (!selectedPeriod) return;

    let availablePeriod = +periodOptions[periodOptions.length - 1]?.value || 0;
    if (selectedPeriod.name.includes('12')) {
      setPeriod(12);
      availablePeriod = 12;
    } else if (selectedPeriod.name.includes('24')) {
      setPeriod(24);
      availablePeriod = 24;
    } else if (selectedPeriod.name.includes('36')) {
      setPeriod(36);
      availablePeriod = 36;
    }

    additionalProducts.forEach((product) => {
      if (product.label === 'Каско СК "Евразия"' && periodOptions.length > 0) {
        const isGreater =
          product.loanPeriod && +product.loanPeriod > availablePeriod;
        handleChangeAddProductLoanPeriod({
          value: isGreater
            ? periodOptions[0].value
            : product.loanPeriod || periodOptions[0].value,
          id: product.id
        });
      }
    });
  }, [stockBonds]);

  useEffect(() => {
    if (period === 12) {
      setPeriodOptions(addProductsLoanPeriodOptions.slice(0, 1));
    } else if (period === 24) {
      setPeriodOptions(addProductsLoanPeriodOptions.slice(0, 2));
    } else if (period === 36) {
      setPeriodOptions(addProductsLoanPeriodOptions.slice(0, 3));
    } else {
      setPeriodOptions(addProductsLoanPeriodOptions);
    }
  }, [period]);

  return { periodOptions };
};

export default useEurasProducts;
